"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _Settings.Settings;
  }
});
Object.defineProperty(exports, "ENDPOINT_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.ENDPOINT_DEFAULT;
  }
});
Object.defineProperty(exports, "ICON_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.ICON_DEFAULT;
  }
});
Object.defineProperty(exports, "ICON_DEFAULT_HOST", {
  enumerable: true,
  get: function get() {
    return _defaults.ICON_DEFAULT_HOST;
  }
});
Object.defineProperty(exports, "LANGUAGE_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.LANGUAGE_DEFAULT;
  }
});
Object.defineProperty(exports, "LOCKING_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.LOCKING_DEFAULT;
  }
});
Object.defineProperty(exports, "PREFIX_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.PREFIX_DEFAULT;
  }
});
Object.defineProperty(exports, "UIMODE_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.UIMODE_DEFAULT;
  }
});
Object.defineProperty(exports, "UITHEME_DEFAULT", {
  enumerable: true,
  get: function get() {
    return _defaults.UITHEME_DEFAULT;
  }
});
Object.defineProperty(exports, "SettingsStruct", {
  enumerable: true,
  get: function get() {
    return _types.SettingsStruct;
  }
});
Object.defineProperty(exports, "NetworkSpecsStruct", {
  enumerable: true,
  get: function get() {
    return _types.NetworkSpecsStruct;
  }
});
exports.default = void 0;

var _Settings = _interopRequireWildcard(require("./Settings"));

var _defaults = require("./defaults");

var _types = require("./types"); // Copyright 2017-2020 @polkadot/ui-settings authors & contributors
// SPDX-License-Identifier: Apache-2.0


var _default = _Settings.default;
exports.default = _default;